import {PurchaseInfoDto} from '../../common/shared/api/nicolas/vo/PurchaseInfoDto.interface';
import {getDateDifference} from '../../common/shared/utils/getDateDifference';
import {PurchaseInfo} from '../generated/types';
import {createPurchaseType} from './PurchaseType';

export function createPurchaseInfo({
  purchase_type,
  rent_expire_dt,
}: PurchaseInfoDto): PurchaseInfo {
  return {
    purchaseType: createPurchaseType(purchase_type),
    rentExpireDate: rent_expire_dt,
    expired: rent_expire_dt
      ? getDateDifference({
          dateLeft: new Date(rent_expire_dt),
          dateRight: new Date(),
        }).totalSeconds <= 0
      : true,
  };
}
